export const API_PATH_ApiDeviceMgmtDevicesConfigPut = '/services/devices-mgtm/apiDeviceMgmtDevicesConfigPut';
